import { render, staticRenderFns } from "./AddOptions.vue?vue&type=template&id=197d1554&scoped=true&"
import script from "./AddOptions.vue?vue&type=script&lang=js&"
export * from "./AddOptions.vue?vue&type=script&lang=js&"
import style0 from "./AddOptions.vue?vue&type=style&index=0&id=197d1554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197d1554",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VIcon,VRow})
